import { createContext } from 'react'

import type { MqttClientInstance, MqttConnectionStatus } from './types'

type MqttContextValue = {
  client: MqttClientInstance
  clientId: string
  connectionStatus: MqttConnectionStatus
}

const MqttContext = createContext<MqttContextValue | null>(null)

export type { MqttContextValue }

export default MqttContext
